<template>
  <section>
    <SignUpThanksHero v-if="npi_status" header=""
                      paragraph="It’s now official, you’re a Sun Hero! Thank you for signing up. When planning your big presentation, please allow 4–6 weeks for delivery of your kits."
                      image="Super-Sam-SunHero-300-large" showButton="false"/>
    <SignUpThanksHero v-else header=""
                      paragraph="Thank you for registering to become a Sun Hero! Your NPI # is currently being verified and we will reach out with any questions. Once your number has been verified, we'll send you an email so you can get started on ordering your kits!"
                      image="Super-Sam-SunHero-300-large" showButton="false"/>
  </section>
</template>
<script>
import SignUpThanksHero from '../thanks/SignUpThanksHero.vue'

export default {
  props: {
    npi_status: false,
  },
  created () {
    setTimeout(() => {
      console.log(' forward to Request Kit Page ')
      this.$router.push({ name: 'Request' }).catch(() => {})
    }, 10000)
  },
  components: {
    SignUpThanksHero,
  },
}
</script>
<style lang="less" scoped>
@import (reference) "~@/assets/css/variables.less";
</style>
